import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { CATEGORY_COLORS, TYPE_COLORS } from "./colors";

export function BadgeColorLegend() {
  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="text-base">Badge Color Coding</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div>
          <p className="text-xs text-muted-foreground uppercase tracking-wide font-semibold mb-2">
            Attendee type
          </p>
          <div className="flex flex-wrap gap-2">
            {Object.entries(TYPE_COLORS).map(([key, { bg, label }]) => (
              <div
                key={key}
                className="inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-medium"
                style={{ backgroundColor: `${bg}15`, borderColor: `${bg}40` }}
              >
                <span
                  className="inline-block w-2.5 h-2.5 rounded-full"
                  style={{ backgroundColor: bg }}
                />
                <span>{label}</span>
              </div>
            ))}
          </div>
        </div>

        <div>
          <p className="text-xs text-muted-foreground uppercase tracking-wide font-semibold mb-2">
            Registration category
          </p>
          <div className="flex flex-wrap gap-2">
            {Object.entries(CATEGORY_COLORS).map(([key, { bg, label }]) => (
              <div
                key={key}
                className="inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-medium"
                style={{ backgroundColor: `${bg}15`, borderColor: `${bg}40` }}
              >
                <span
                  className="inline-block w-2.5 h-2.5 rounded-full"
                  style={{ backgroundColor: bg }}
                />
                <span>{label}</span>
              </div>
            ))}
          </div>
        </div>

        <p className="text-xs text-muted-foreground">
          The badge ribbon and top strip use the registration category color (or attendee type override for children/teens/students).
        </p>
      </CardContent>
    </Card>
  );
}
